import Vue from 'vue'
import App from './App.vue'
// @ts-ignore
import vuetify from './plugins/vuetify';
import '@mdi/font/css/materialdesignicons.css'

// @ts-ignore
import router from '@/router'

// @ts-ignore
import store from '@/store/store'

// @ts-ignore
import * as http from '@/components/httpclient/http-client'

// @ts-ignore
import VCalendar from 'v-calendar'

Vue.config.productionTip = false

Vue.use(http.HttpClientPlugin);
Vue.use(VCalendar, {
  componentPrefix: 'vc'
});

Vue.prototype.$alert = (payload: string | object) => {
  if (typeof payload === 'string' || payload instanceof String) {
    store.dispatch('globalAlert', {
      text: payload
    });
  } else {
    store.dispatch('globalAlert', payload);
  }
}


new Vue({
  // @ts-ignore
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
